import React, { useState, useEffect } from 'react';
import { LogOut, User } from 'lucide-react';
import { useAuth } from '../../hooks/useAuth';
import { companyService } from '../../services/companyService';

const Header = () => {
  const { user, logout } = useAuth();
  const [companyLogo, setCompanyLogo] = useState('');
  const [companyName, setCompanyName] = useState('');

  // Load company info if user is from a company
  useEffect(() => {
    const loadCompanyInfo = async () => {
      if (user && user.role === 'company' && user.companyId) {
        try {
          const company = await companyService.getById(user.companyId);
          setCompanyLogo(company.logo || '');
          setCompanyName(company.name || '');
        } catch (error) {
          console.error('Erro ao carregar informações da empresa:', error);
        }
      }
    };

    loadCompanyInfo();
  }, [user]);

  const handleLogout = async () => {
    try {
      await logout();
    } catch (error) {
      console.error('Erro ao fazer logout:', error);
    }
  };

  const getDisplayTitle = () => {
    if (user && user.role === 'company' && companyName) {
      return companyName;
    }
    return 'MeuFiel';
  };

  const renderLogo = () => {
    if (user && user.role === 'company' && companyLogo) {
      return (
        <div className="h-8 w-8 rounded overflow-hidden border border-gray-200 bg-white flex items-center justify-center">
          <img 
            src={companyLogo} 
            alt="Logo da empresa" 
            className="h-full w-full object-contain"
          />
        </div>
      );
    }
    // Usar a logo padrão do MeuFiel
    return (
      <div className="h-8 w-8 rounded overflow-hidden border border-gray-200 bg-white flex items-center justify-center">
        <img 
          src="/logo1200.png" 
          alt="MeuFiel Logo" 
          className="h-full w-full object-contain"
        />
      </div>
    );
  };

  return (
    <header className="bg-white shadow-sm border-b">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          <div className="flex items-center">
            {renderLogo()}
            <h1 className="ml-2 text-xl font-bold text-gray-900">{getDisplayTitle()}</h1>
          </div>
          
          <div className="flex items-center space-x-4">
            {user && (
              <>
                <div className="flex items-center space-x-2">
                  <User className="h-5 w-5 text-gray-500" />
                  <span className="text-sm text-gray-700">
                    {user.name || user.email}
                  </span>
                  {user.role === 'admin' && (
                    <span className="bg-red-100 text-red-800 text-xs px-2 py-1 rounded-full">
                      Admin
                    </span>
                  )}
                  {user.role === 'company' && (
                    <span className="bg-blue-100 text-blue-800 text-xs px-2 py-1 rounded-full">
                      Empresa
                    </span>
                  )}
                </div>
                <button
                  onClick={handleLogout}
                  className="flex items-center space-x-1 text-gray-700 hover:text-gray-900 transition-colors"
                >
                  <LogOut className="h-4 w-4" />
                  <span className="text-sm">Sair</span>
                </button>
              </>
            )}
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
